<template>
  <svg
    width="51"
    height="51"
    viewBox="0 0 51 51"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="51" height="51" rx="10" fill="#F1F8FF" />
    <path
      d="M29.5282 40.0007V31.334C29.5282 30.7817 29.0805 30.334 28.5282 30.334H22.4727C21.9204 30.334 21.4727 30.7817 21.4727 31.334V40.0007"
      stroke="url(#paint0_linear_1_346)"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.2227 23.8887V35.9998C14.2227 37.8854 14.2227 38.8282 14.8084 39.414C15.3942 39.9998 16.337 39.9998 18.2227 39.9998H32.7782C34.6638 39.9998 35.6066 39.9998 36.1924 39.414C36.7782 38.8282 36.7782 37.8854 36.7782 35.9998V23.8887"
      stroke="url(#paint1_linear_1_346)"
      stroke-width="2"
    />
    <path
      d="M13.8435 12.5149C14.0254 11.7874 14.1163 11.4236 14.3876 11.2118C14.6588 11 15.0338 11 15.7838 11H35.2162C35.9662 11 36.3412 11 36.6124 11.2118C36.8837 11.4236 36.9746 11.7874 37.1565 12.5149L39.3787 21.4038C39.6647 22.5477 39.8077 23.1197 39.5074 23.5043C39.2072 23.8889 38.6176 23.8889 37.4384 23.8889H36.9441C35.3257 23.8889 34.5166 23.8889 33.9571 23.4149C33.3976 22.941 33.2645 22.1428 32.9985 20.5465L32.9473 20.2392C32.8722 19.789 32.8347 19.5638 32.75 19.5638C32.6653 19.5638 32.6278 19.789 32.5527 20.2392L32.408 21.1078C32.2325 22.1604 32.1448 22.6866 31.864 23.0703C31.6772 23.3254 31.4326 23.5327 31.1502 23.675C30.7256 23.8889 30.1921 23.8889 29.125 23.8889V23.8889C28.0579 23.8889 27.5244 23.8889 27.0998 23.675C26.8174 23.5327 26.5728 23.3254 26.386 23.0703C26.1052 22.6866 26.0175 22.1604 25.842 21.1078L25.6973 20.2392C25.6222 19.789 25.5847 19.5638 25.5 19.5638C25.4153 19.5638 25.3778 19.789 25.3027 20.2392L25.158 21.1078C24.9825 22.1604 24.8948 22.6866 24.614 23.0703C24.4272 23.3254 24.1826 23.5327 23.9002 23.675C23.4756 23.8889 22.9421 23.8889 21.875 23.8889V23.8889C20.8079 23.8889 20.2744 23.8889 19.8498 23.675C19.5674 23.5327 19.3228 23.3254 19.136 23.0703C18.8552 22.6866 18.7675 22.1604 18.592 21.1078L18.4473 20.2392C18.3722 19.789 18.3347 19.5638 18.25 19.5638C18.1653 19.5638 18.1278 19.789 18.0527 20.2392L18.0015 20.5465C17.7355 22.1428 17.6024 22.941 17.0429 23.4149C16.4834 23.8889 15.6743 23.8889 14.0559 23.8889H13.5616C12.3824 23.8889 11.7928 23.8889 11.4926 23.5043C11.1923 23.1197 11.3353 22.5477 11.6213 21.4038L13.8435 12.5149Z"
      stroke="url(#paint2_linear_1_346)"
      stroke-width="2"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1_346"
        x1="24.9329"
        y1="27.6097"
        x2="32.0217"
        y2="29.0866"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4478FF" />
        <stop offset="1" stop-color="#45B2FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1_346"
        x1="23.9113"
        y1="19.3483"
        x2="42.3613"
        y2="25.8058"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4478FF" />
        <stop offset="1" stop-color="#45B2FF" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1_346"
        x1="23.4568"
        y1="7.36768"
        x2="43.6841"
        y2="18.7455"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4478FF" />
        <stop offset="1" stop-color="#45B2FF" />
      </linearGradient>
    </defs>
  </svg>
</template>
